import axios from "./axios";

class UserRepository {
  searchByEmail(email) {
    return axios
      .get(`/admin/users?email=${encodeURIComponent(email)}`)
      .then((response) => {
        return response.data.users.data;
      });
  }

  save(user) {
    return axios.post(`/admin/users`, user).then((response) => {
      return response.data;
    });
  }
}

export default new UserRepository();



// WEBPACK FOOTER //
// ./src/data/user.repository.js